import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, GenericLinkComponent, MediaComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KnBrNavigationService } from '../services/kn-br-navigation.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-navigation',
    templateUrl: './kn-br-navigation.component.html',
    styleUrls: ['./kn-br-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GenericLinkComponent, MediaComponent, AsyncPipe]
})
export class KnBrNavigationComponent {
  node$: Observable<any> = this.service.createNavigation(this.componentData.data$);
  styleClass$: Observable<string> = this.componentData.data$.pipe(map((d) => d?.styleClass));
  istoggleOpen = false;
  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: KnBrNavigationService
  ) {}

  toggle(node, index: number) {
    this.closeRemainingMenus(index);
    node.active = !node.active;
    this.istoggleOpen = !this.istoggleOpen;
  }

  closeRemainingMenus(index: number) {
    this.node$.subscribe((res) => {
      if (res && res.children && res.children.length > 0) {
        const nodes: any[] = res.children[0];
        Object.values(nodes)
          .filter((menu, i) => i !== index && menu.active)
          .forEach((menu) => (menu.active = !menu.active));
      }
    });
  }

  onMouseEnter(node, index: number) {
    this.closeRemainingMenus(index);
    node.active = true;
  }

  onMouseLeave(node, index: number) {
    this.closeRemainingMenus(index);
    node.active = false;
  }
}
